import {type DocumentFieldAction} from './types'

export * from './define'
export * from './reducer'
export * from './types'

/** @internal */
export const initialDocumentFieldActions: DocumentFieldAction[] = []
